import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { subMenuItems } from '@auth/payments/submenu';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';
import { ApiService } from '@shared/services/api.service';
import { PaymentsMenuService } from '@shared/services/payments-menu.service';
import { UtilsService } from '@shared/services/utils.service';
import { format, parse } from 'date-fns';
import { es } from 'date-fns/locale';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent {
  setting: any = {};
  invoiceNumber: string = '';
  invoice: any = {};
  time: any = '';
  public results: any[] = [];
  statusText: string = '';
  public isButtonSaveInvoiceDisabled: boolean = false;
  invoiceDetails: any[] = [];
  totals: any = {
    totalBase: 0,
    totalTaxes: 0,
    totalEur: 0
  }
  public subMenuItems: Array<IToolbarItem> = [];
  public formCustomer!: FormGroup;
  public selectedCustomer: any = null;
  public formAddressCustomer!: FormGroup;
  public transactionModalVisible: boolean = false;
  public selectedAddress: any = null;
  public warningMessage!: string;
  public submitAttemptedCustomer: boolean = false;
  public transactionForms: FormGroup[] = [];
  public isTransactionsValid: boolean = false;
  public isTransactionsOmited: boolean = false;
  public transactions: any[] = [];
  public formSteps: { [key: string]: boolean } = {
    'serviceDataForm': false,
    'customerDataForm': false,
    'addressCustomerForm': false,
  }

  constructor(
    public apiService: ApiService,
    public activatedRoute: ActivatedRoute,
    public utils: UtilsService,
    public messageService: MessageService,
    private subMenuService: PaymentsMenuService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.formCustomer = this.formBuilder.group({
      name: ['', [Validators.required]],
      cif: [''],
      phone: [''],
      email: ['', [Validators.email]],
    });
    this.formAddressCustomer = this.formBuilder.group({
      street_name: ['', [Validators.required]],
      street_number: ['', [Validators.required]],
      floor: [''],
      description: [''],
      city: ['', [Validators.required]],
      province: [''],
      country: ['', [Validators.required]],
      postal_code: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9\\s\\-]{5,}$')]]
    });
    this.subMenuItems = this.subMenuService.getSubMenuItems();
    let invoiceId = this.activatedRoute.snapshot.params['id'];
    this.apiService.getInvoiceById(invoiceId).subscribe((response: any) => {

      this.invoice = response;
      this.invoiceDetails = this.invoice.details;

      this.setting = JSON.parse(localStorage.getItem('me') ?? '').setting;

      this.invoiceNumber = this.invoice.reference;

      this.invoiceDetails = this.invoiceDetails.map((detail: any) => {

        detail['edited'] = false;
        if (detail['unit_price'] != 0) {
          detail['detail_subtotal'] = (detail['unit_price'] - (detail['unit_price'] * (detail['vat'] / 100))) * detail['units'];
          detail['base_tax'] = (parseFloat(detail['unit_price']) * detail['units']) - detail['detail_subtotal'];
        } else {
          detail['unit_price'] = 0;
          detail['detail_subtotal'] = 0;
          detail['base_tax'] = 0;
        }
        detail['booking_id'] = null;
        return detail;
      });

      if (this.invoice.invoice_created_at == null) {
        this.time = format(new Date, "dd/MM/yyyy HH:mm:ss", { locale: es });
      } else {
        const date = parse(this.invoice.invoice_created_at, "yyyy-MM-dd HH:mm:ss", new Date(), { locale: es });
        this.time = format(date, "dd/MM/yyyy HH:mm:ss", { locale: es });
      }

      switch (this.invoice.status_id) {
        case 2:
          this.statusText = 'Pendiente de pago';
          break;
        case 4:
          this.statusText = 'Pagado';
          break;
        case 6:
          this.statusText = 'Anulada';
          break;
      }

      this.apiService.getCustomersPaginated(this.invoice.customer_email).subscribe((response: any) => {
        this.selectedCustomer = response[0];
        this.refreshCustomer();
      });
      this.addTransactionForm();
      this.calculateTotals();
    });
  }

  refreshCustomer() {
    this.invoice.customer_name = this.selectedCustomer?.name;
    this.invoice.customer_cif = this.selectedCustomer?.cif;
    this.invoice.customer_phone = this.selectedCustomer?.phone;
    this.invoice.customer_email = this.selectedCustomer?.email;
    this.invoice.customer_address = `${this.selectedCustomer.address?.street_name || ''} ${this.selectedCustomer.address?.street_number || ''} ${this.selectedCustomer.address?.floor || ''} ${this.selectedCustomer.address?.description || ''} ${this.selectedCustomer.address?.city || ''} ${this.selectedCustomer.address?.province || ''} ${this.selectedCustomer.address?.country || ''} ${this.selectedCustomer.address?.postal_code || ''}`.trim();
  }

  isCustomerDataModified(data: any): boolean {
    return (
      data.name !== this.selectedCustomer.name ||
      data.cif !== this.selectedCustomer.cif ||
      data.phone !== this.selectedCustomer.phone ||
      data.email !== this.selectedCustomer.email
    );
  }

  saveCustomer() {
    if (this.formCustomer.valid) {
      this.submitAttemptedCustomer = false;
      const customerFormData = this.formCustomer.value;
      if (this.selectedCustomer) {
        if (this.isCustomerDataModified(customerFormData)) {
          this.updateCustomer(customerFormData);
        } else {
          this.toggleForm('customerDataForm');
        }
      } else {
        this.createCustomer(customerFormData);
      }
      this.refreshCustomer();

      // this.cdr.detectChanges();
    }
  }

  createCustomer(customerData: any) {
    this.apiService.post('/customer/create', customerData).subscribe(
      (response: any) => {
        this.selectedCustomer = response;
        this.selectedCustomer.addresses = [];
        this.toggleForm('customerDataForm')
      },
      (error) => {
        console.log('Error al crear cliente', error);
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  updateCustomer(customerData: any) {
    this.apiService.post(`/customer/update/${this.selectedCustomer.id}`, customerData).subscribe(
      (response: any) => {
        this.selectedCustomer = { ...this.selectedCustomer, ...customerData };
        this.toggleForm('customerDataForm');
      },
      (error) => {
        console.log('error actualizar cliente', error);
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  toggleForm(section: string) {
    this.formSteps[section] = !this.formSteps[section];
  }

  searchCustomer(event: any) {
    const query = event.query;
    if (query && query.length > 2) {
      this.apiService.getCustomersPaginated(query.toLowerCase()).subscribe((response: any) => {
        this.results = response;
      });
    } else {
      this.results = [];
    }
  }

  onSelectCustomer(event: any) {
    console.log('event', event);
    this.selectedCustomer = event.value;
    this.refreshCustomer();
    this.formCustomer.patchValue({
      name: this.selectedCustomer.name,
      cif: this.selectedCustomer.cif,
      phone: this.selectedCustomer.phone,
      email: this.selectedCustomer.email
    });
  }

  handleValidationErrors(validationData: any) {
    Object.keys(validationData).forEach(key => {
      const errorMessages = validationData[key];
      const messageToast = ` ${errorMessages.join(", ")}`;
      this.messageService.add({ severity: 'error', summary: 'Error de validación', detail: messageToast, life: 30000 });
    });
  }

  editAddress(address: any) {
    this.selectedAddress = address;
    this.formAddressCustomer.patchValue(address);
    this.toggleForm('addressCustomerForm');
  }

  deleteAddress(address: any) {
    if (this.selectedCustomer) {
      const addressToDelete = this.selectedCustomer.address;
      if (addressToDelete) {
        this.apiService.post(`/address/delete/${address.id}`, address).subscribe(
          (response: any) => {

          },
          (error) => {
            if (error && error.error && error.error.data) {
              this.handleValidationErrors(error.error.data);
            }
          }
        );
        this.selectedCustomer.address = null;
        this.selectedAddress = null;
      }
    }
  }

  saveAddressCustomer() {
    const addressNewData = this.formAddressCustomer.value;

    if (this.selectedCustomer) {
      if (this.selectedAddress) {
        const addressSearched = this.selectedCustomer.address;

        if (addressSearched) {
          this.updateAddress(this.selectedAddress);
        }

      } else {
        this.createAddress(addressNewData);
      }
      if (this.isFormValid(this.formAddressCustomer)) {
        this.formAddressCustomer.reset();
        this.toggleForm('addressCustomerForm');
      }


    } else {
      this.warningMessage = '¡Necesitas seleccionar un cliente!';
    }
  }

  isFormValid(form: FormGroup): boolean {
    return form.valid;
  }

  updateAddress(customerAddressData: any) {
    const addressId = customerAddressData.id;
    this.apiService.post(`/address/update/${addressId}`, this.formAddressCustomer.value).subscribe(
      (response: any) => {
        // const index = this.selectedCustomer.addresses.indexOf(this.selectedAddress);
        // if (index !== -1) {
        //   this.selectedCustomer.addresses[index] = response.address;
        //   this.selectedAddress = null;
        // }
        this.selectedCustomer.address = response.address;
        this.selectedAddress = null;
      },
      (error) => {
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  createAddress(customerAddressData: any) {
    this.apiService.post(`/address/create/${this.selectedCustomer.id}`, customerAddressData).subscribe(
      (response: any) => {
        this.selectedCustomer.address = response.address;

      },
      (error) => {
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  handleInputData(event: any, attribute: string, detailId: number) {

    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    const keyPressed = event.key;
    let inputValue = event.target.value;
    const inputElement = event.target;
    let selectionStartEarly = inputElement.selectionStart;

    if (attribute == 'units') {

      if (/\D/.test(keyPressed) && !allowedKeys.includes(keyPressed)) {
        event.target.value = '';
        event.preventDefault();
        return;
      }

      if (inputValue.trim() == '') {
        inputValue = '0';
        event.target.value = '0';
      }

      this.recalculateAll(inputValue, attribute, detailId, inputElement);



    } else if (attribute == 'vat') {

      if (/\D/.test(keyPressed) && !allowedKeys.includes(keyPressed)) {
        event.target.value = '';
        event.preventDefault();
        return;
      }

      if (inputValue.trim() == '') {
        inputValue = '0';
        event.target.value = '0';
      }

      this.recalculateAll(inputValue, attribute, detailId, inputElement);

    } else if (attribute == 'unit_price') {
      if (inputValue.trim() == '') {
        inputValue = '0';
      }
      this.recalculateAll(inputValue, attribute, detailId, inputElement);
    } else {
      this.recalculateAll(inputValue, attribute, detailId, inputElement);

    }
  }

  recalculateAll(inputValue: any, attribute: string, detailId: number, inputElement?: any) {

    this.invoiceDetails = this.invoiceDetails.map((detail: any) => {
      if (detail.id == detailId) {
        detail['edited'] = true;
        let totalValue: any = 0;

        if (attribute == 'units') {
          detail['units'] = parseInt(inputValue, 10);
        } else if (attribute == 'vat') {
          detail['vat'] = parseInt(inputValue, 10);

        } else if (attribute == 'unit_price') {

          totalValue = parseFloat(inputValue);
          if (totalValue == 0) {
            detail['unit_price'] = '0';
          } else {
            detail['unit_price'] = totalValue;
          }

        } else if (attribute == 'concept') {

          detail['concept'] = inputValue.toString();

        }

        if (attribute == 'units' || attribute == 'unit_price' || attribute == 'vat') {
          if (detail['unit_price'] != 0) {
            detail['detail_subtotal'] = (detail['unit_price'] - (detail['unit_price'] * (detail['vat'] / 100))) * detail['units'];
            detail['base_tax'] = (parseFloat(detail['unit_price']) * detail['units']) - detail['detail_subtotal'];
          } else {
            detail['unit_price'] = 0;
            detail['detail_subtotal'] = 0;
            detail['base_tax'] = 0;
          }

          if (detail['unit_price'] == '0') {
            detail['unit_price'] = '0.00';
          } else {
            detail['unit_price'] = Number(detail['unit_price']).toFixed(2);
          }
          this.calculateTotals();
        }
      }


      return detail;
    });

  }

  calculateTotals() {
    this.totals['totalEur'] = 0;
    this.totals['totalTaxes'] = 0;
    this.totals['totalBase'] = 0;
    for (let detail of this.invoiceDetails) {
      if (detail['unit_price'] != 0) {
        this.totals['totalEur'] += detail['detail_subtotal'];
      }
    }
    this.totals['totalBase'] = Number(this.totals['totalEur']) / (1 + (Number(this.setting.tax) / 100));
    this.totals['totalTaxes'] = Number(this.totals['totalEur']) - this.totals['totalBase'];
    this.invoice.total = this.totals['totalEur'];
  }

  setInputToZero(event: any, attribute: string, detailId: number) {
    if (attribute == 'units' || attribute == 'base_price') {
      let inputValue = (event.target?.value ?? event).toString();
      if (inputValue.trim() == '') {
        inputValue = '0';
        this.recalculateAll(inputValue, attribute, detailId);
      }
    }
  }

  validateOnlyFloat(event: any) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    const keyPressed = event.key;

    // Obtener el valor actual del input
    const currentValue = event.target.value;
    const hasMultipleDots = currentValue.split('.').length > 2;

    if (
      (!/^\d$/.test(keyPressed) && keyPressed !== '.' && !allowedKeys.includes(keyPressed)) ||
      hasMultipleDots
    ) {
      // Solo borra el campo si el carácter es completamente inválido (no números ni punto adicional)
      event.target.value = '';
      event.preventDefault();
      return;
    }
  }

  updateInvoice() {
    if (!this.invoice.customer_name || this.invoice.customer_name?.trim() == '') {
      this.messageService.add({ severity: 'error', summary: 'Factura', detail: 'Adjunte un cliente a la factura.' });
      this.isButtonSaveInvoiceDisabled = false;
      return;
    }
    this.isButtonSaveInvoiceDisabled = true;
    console.log('invoice details: ', this.invoiceDetails);
    this.apiService.updateInvoiceDetails(this.invoiceDetails).subscribe((response: any) => {
      this.apiService.updateInvoice(this.invoice).subscribe((response: any) => {
        // let ticketId = this.invoice.ticket_id || this.invoice.booking?.details?.ticket?.id;
        // this.transactions = this.transactions.map((transaction: any) => {
        //   transaction.ticket_id = ticketId;
        //   return transaction;
        // });
        // this.apiService.post('/cashier-entry/invoice/update-all', { cashier_entries: this.transactions })
        //   .subscribe({
        //     next: (response: any) => {
        //       this.messageService.add({ severity: 'success', summary: 'Transacción', detail: 'Transacciones creadas correctamente.' });
        //     },
        //     error: (error) => {
        //       console.log('Error al crear transacciones', error);
        //       if (error && error.error && error.error.data) {
        //         this.handleValidationErrors(error.error.data);
        //       }
        //     },
        //     complete: () => {
        //       this.resetInvoiceForm();
        //       this.isButtonSaveInvoiceDisabled = false;
        //     }
        //   });
        this.isButtonSaveInvoiceDisabled = false;
        this.messageService.add({ severity: 'success', summary: 'Detalles actualizados', detail: 'Factura actualizada correctamente.' });
      });
    });
  }

  openTransactionModal() {
    this.transactionModalVisible = true;
  }

  addTransactionForm() {
    const transactionForm = this.formBuilder.group({
      payment_method: ['EFECTIVO', Validators.required],
      amount: ['', [Validators.required, Validators.pattern('^[0-9]+(\.[0-9]{1,2})?$')]]
    });
    this.transactionForms.push(transactionForm);
  }

  removeTransactionForm(index: number) {
    if (this.transactionForms.length > 1) {
      this.transactionForms.splice(index, 1);
    }
  }

  getTotalTransactionAmount(): number {
    return this.transactionForms.reduce((total, form) => total + parseFloat(form.get('amount')?.value || '0'), 0);
  }

  saveTransactions() {
    this.isTransactionsValid = false;
    const transactions = this.transactionForms.map(form => {
      if (form.valid) {
        return {
          received: form.value.amount,
          ...form.value
        };
      }
      return null;
    }).filter(transaction => transaction !== null);

    if (this.getTotalTransactionAmount() > this.invoice.total) {
      this.messageService.add({ severity: 'error', summary: 'Transacción', detail: 'El monto total de las transacciones no puede superar el monto total de la factura.' });
      return;
    }
    this.isButtonSaveInvoiceDisabled = false;
    this.isTransactionsValid = true;
    console.log('transactions: ', transactions);
    this.transactions = transactions;

    this.transactionModalVisible = false;
  }
}